<template>
    <div class="container bg-light">
        <h1 class="bg-warning text-light rounded-pill">Nieuws</h1>
        <h3 class="p-2 rounded-pill">De TOS headlines</h3>

        <div class="d-flex justify-content-around flex-wrap">
        <div v-for="artikel in artikelen" v-bind:key="artikel.id" v-on:click="navigate(artikel.id)">
            <artikel-header :titel="artikel.titel" :img="artikel.img">
            </artikel-header>
        </div>
    </div>
    </div>
</template>
<script>
    import artikels from '@/assets/artikelen.json';
    import ArtikelHeader from '@/components/ArtikelHeader.vue'
    export default {
        name: 'Index',
        components: {
            ArtikelHeader
        },
        data() {
            return {
                artikelen: artikels
            }
        },
        methods: {
            navigate(id) {
                console.log("nav");
                this.$router.push('/artikel/'+id);
            }
        }
    }
</script>
<style scoped>
    h3 {
        background-color: lightblue;
    }
</style>

